
import { camelCasedObjectToSnakeCasedObject } from '../../../../utilities/randomUtilities'

const initialState = {
  isFetching: false,
  errors: [],
  activities: [],
  pagination: {}
}

export const REQUEST_CURRENT_JOB_ACTIVITIES_ACTIONS = 'REQUEST_CURRENT_JOB_ACTIVITIES_ACTIONS'
export const RECEIVE_CURRENT_JOB_ACTIVITIES_SUCCESS = 'RECEIVE_CURRENT_JOB_ACTIVITIES_SUCCESS'
export const RECEIVE_CURRENT_JOB_ACTIVITIES_FAILURE = 'RECEIVE_CURRENT_JOB_ACTIVITIES_FAILURE'

export default function currentJobActivitiesReducer (reduxState = initialState, action) {
  const { type, payload } = action
  switch (type) {
    case REQUEST_CURRENT_JOB_ACTIVITIES_ACTIONS:
      return {
        ...reduxState,
        isFetching: true,
        errors: []
      }
    case RECEIVE_CURRENT_JOB_ACTIVITIES_SUCCESS:
      return {
        ...reduxState,
        isFetching: false,
        activities: payload.activities,
        pagination: camelCasedObjectToSnakeCasedObject(payload.pagination)
      }
    case RECEIVE_CURRENT_JOB_ACTIVITIES_FAILURE:
      return {
        ...reduxState,
        isFetching: false,
        errors: payload.errors
      }
    default:
      return reduxState
  }
}
